import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const userNotificationService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/user-notification`,

  getUserNotifications(organizationId) {
    return viperApi.get(this.basePath(organizationId))
  },

  markAsRead(organizationId, params) {
    return viperApi.put(`${this.basePath(organizationId)}/read`, params)
  },

  markAsReadForTrial(organizationId, params) {
    return viperApi.put(`${this.basePath(organizationId)}/read-all-for-trial`, params)
  },

  markAllAsReadForPatient(organizationId, params) {
    return viperApi.put(`${this.basePath(organizationId)}/read-all-for-patient`, params)
  },

  markAllAsReadForLoggedInUser(organizationId) {
    return viperApi.put(`${this.basePath(organizationId)}/mark-all-as-read`)
  }
}
